var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 31,
    viewBox: "0 0 41 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 31V22.8421C0.5 20.3645 0.933483 17.7359 1.80045 14.9561C2.69731 12.1462 3.98281 9.44201 5.65695 6.84357C7.36099 4.21491 9.40882 1.93372 11.8004 0L17.5404 4.71345C15.657 7.43275 14.0127 10.2729 12.6076 13.2339C11.2324 16.1647 10.5448 19.307 10.5448 22.6608V31H0.5ZM23.4596 31V22.8421C23.4596 20.3645 23.8931 17.7359 24.7601 14.9561C25.6569 12.1462 26.9425 9.44201 28.6166 6.84357C30.3206 4.21491 32.3685 1.93372 34.7601 0L40.5 4.71345C38.6166 7.43275 36.9723 10.2729 35.5673 13.2339C34.1921 16.1647 33.5045 19.307 33.5045 22.6608V31H23.4596Z",
    fill: "#1C75BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.e646affc91fc7be79092efa119d853ab.svg";
export { ForwardRef as ReactComponent };